import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PublicLayout from "../components/layouts/PublicLayout";
import "../style/nft-collection-mainpage.css";
import { useWeb3React } from "@web3-react/core";

const NftCollectionMainpage = (props) => {
  const { setAccount, setBalance } = props;
  const { account } = useWeb3React();

  return (
    <PublicLayout
      balance={0}
      account={account}
      setAccount={setAccount}
      setBalance={setBalance}
    >
      <>
        <div className="banner-section">
          <div className="banner-container">
            <h1>
              PASSPHRASE <span className="yellow-text">PRIVACY</span>
            </h1>
            <p>
              Effective date: January 10th, 2022 <br />
              Passphrase ("us", "we", or "our") operates the website.
              <br />
              This page informs you of our policies regarding the collection,
              use, and disclosure of personal data when you use our Service and
              the choices you have associated with that data. <br />
              We use your data to provide and improve the Service. By using the
              Service, you agree to the collection and use of information in
              accordance with this policy. Unless otherwise defined in this
              Privacy Policy, terms used in this Privacy Policy have the same
              meanings as in our Terms and Conditions.
            </p>
          </div>
        </div>
        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>I. INFORMATION COLLECTION AND USE</h1>
            </div>
          </div>
        </div>

        <div className="banner-section1">
          <div className="banner-container">
            <p>
              We collect several different types of information for various
              purposes to provide and improve our Service to you. <br />
              If you do not use (log in to) the service for two years all your
              personal data will be deleted. <br />
              Types of Data Collected:
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h6>1. Personal Data</h6>
            </div>
          </div>
        </div>

        <div className="banner-section1">
          <div className="banner-container">
            <p>
              While using our Service, we may ask you to provide us with certain
              personally identifiable information that can be used to contact or
              identify you ("Personal Data"). Personally identifiable
              information may include, but is not limited to: <br />
              Email address Cookies and Usage Data
            </p>
          </div>
        </div>
        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h6>2. Usage Data</h6>
            </div>
          </div>
        </div>

        <div className="banner-section1">
          <div className="banner-container">
            <p>
              We may also collect information that your browser sends whenever
              you visit our Service or when you access the Service by or through
              a mobile device ("Usage Data"). <br />
              This Usage Data may include information such as your computer's
              Internet Protocol address (e.g. IP address), browser type, browser
              version, the pages of our Service that you visit, the time and
              date of your visit, the time spent on those pages, unique device
              identifiers and other diagnostic data. <br />
              When you access the Service by or through a mobile device, this
              Usage Data may include information such as the type of mobile
              device you use, your mobile device unique ID, the IP address of
              your mobile device, your mobile operating system, the type of
              mobile Internet browser you use, unique device identifiers and
              other diagnostic data.
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h6>3. Tracking Cookies Data</h6>
            </div>
          </div>
        </div>

        <div className="banner-section1">
          <div className="banner-container">
            <p>
              We use cookies and similar tracking technologies to track the
              activity on our Service and hold certain information. <br />
              Cookies are files with small amount of data which may include an
              anonymous unique identifier. Cookies are sent to your browser from
              a website and stored on your device. Tracking technologies also
              used are beacons, tags, and scripts to collect and track
              information and to improve and analyze our Service.
              <br />
              You can instruct your browser to refuse all cookies or to indicate
              when a cookie is being sent. However, if you do not accept
              cookies, you may not be able to use some portions of our Service.
              <br />
              Examples of Cookies we use:
              <br />
              Session Cookies. We use Session Cookies to operate our Service.
              Preference Cookies. We use Preference Cookies to remember your
              preferences and various settings. Security Cookies. We use
              Security Cookies for security purposes.
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>II. USE OF DATA</h1>
            </div>
          </div>
        </div>
        <div className="banner-section1">
          <div className="banner-container">
            <p>
              Passphrase uses the collected data for various purposes:
              <br />
              To provide and maintain the Service To notify you about changes to
              our Service To allow you to participate in interactive features of
              our Service when you choose to do so To provide customer care and
              support To provide analysis or valuable information so that we can
              improve the Service To monitor the usage of the Service To detect,
              prevent and address technical issues III. TRANSFER OF DATA Your
              information, including Personal Data, may be transferred to — and
              maintained on — computers located outside of your state, province,
              country or other governmental jurisdiction where the data
              protection laws may differ than those from your jurisdiction.
              <br />
              If you are located outside United States and choose to provide
              information to us, please note that we transfer the data,
              including Personal Data, to United States and process it there.
              <br />
              Your consent to this Privacy Policy followed by your submission of
              such information represents your agreement to that transfer.
              <br />
              Passphrase will take all steps reasonably necessary to ensure that
              your data is treated securely and in accordance with this Privacy
              Policy and no transfer of your Personal Data will take place to an
              organization or a country unless there are adequate controls in
              place including the security of your data and other personal
              information
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>III. DISCLOSURE OF DATA</h1>
            </div>
          </div>
        </div>
        <div className="banner-section1">
          <div className="banner-container">
            <p>
              Legal Requirements Passphrase may disclose your Personal Data in
              the good faith belief that such action is necessary to: <br />
              To comply with a legal obligation To protect and defend the rights
              or property of Passphrase To prevent or investigate possible
              wrongdoing in connection with the Service To protect the personal
              safety of users of the Service or the public To protect against
              legal liability V. SECURITY OF DATA The security of your data is
              important to us, but remember that no method of transmission over
              the Internet, or method of electronic storage is 100% secure.
              While we strive to use commercially acceptable means to protect
              your Personal Data, we cannot guarantee its absolute security.
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>IV. SERVICE PROVIDERS</h1>
            </div>
          </div>
        </div>
        <div className="banner-section1">
          <div className="banner-container">
            <p>
              We may employ third party companies and individuals to facilitate
              our Service ("Service Providers"), to provide the Service on our
              behalf, to perform Service-related services or to assist us in
              analyzing how our Service is used.
              <br />
              These third parties have access to your Personal Data only to
              perform these tasks on our behalf and are obligated not to
              disclose or use it for any other purpose.
              <br />
              Analytics We may use third-party Service Providers to monitor and
              analyze the use of our Service.
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>V. LINKS TO OTHER SITES</h1>
            </div>
          </div>
        </div>
        <div className="banner-section1">
          <div className="banner-container">
            <p>
              Our Service may contain links to other sites that are not operated
              by us. If you click on a third party link, you will be directed to
              that third party's site. We strongly advise you to review the
              Privacy Policy of every site you visit. <br />
              We have no control over and assume no responsibility for the
              content, privacy policies or practices of any third party sites or
              services.
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>VI. CHILDREN'S PRIVACY</h1>
            </div>
          </div>
        </div>
        <div className="banner-section1">
          <div className="banner-container">
            <p>
              Our Service does not address anyone under the age of 18
              ("Children"). <br />
              We do not knowingly collect personally identifiable information
              from anyone under the age of 18. If you are a parent or guardian
              and you are aware that your Children has provided us with Personal
              Data, please contact us. If we become aware that we have collected
              Personal Data from children without verification of parental
              consent, we take steps to remove that information from our
              servers.
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>VII. CHANGES TO THIS PRIVACY POLICY</h1>
            </div>
          </div>
        </div>
        <div className="banner-section1">
          <div className="banner-container">
            <p>
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.{" "}
              <br />
              We will let you know via email and/or a prominent notice on our
              Service, prior to the change becoming effective and update the
              "effective date" at the top of this Privacy Policy. <br />
              You are advised to review this Privacy Policy periodically for any
              changes. Changes to this Privacy Policy are effective when they
              are posted on this page.
            </p>
          </div>
        </div>

        <div className="slider-wrapper1">
          <div className="slider-top-row1">
            <div className="slider-top-contact">
              <h1>VIII. CONTACT US</h1>
            </div>
          </div>
        </div>
        <div className="banner-section1">
          <div className="banner-container">
            <p>
              If you have any questions about this Privacy Policy, please
              contact us: Email: ath@passphrase.live <br />
              If you would like to know what kind of information we are storing
              regarding your user, please email ath@passphrase.live and use the
              subject “PASS: user” <br />
              If you would like your personal data deleted, please email
              ath@passphrase.live and use the subject: “Delete:User”
            </p>
          </div>
        </div>
      </>
    </PublicLayout>
  );
};

export default NftCollectionMainpage;
